import React, { useRef, useState } from 'react';
import Transition from '../utils/Transition.js';

function PlatformTabs() {
    const [tab, setTab] = useState(1);
    const tabs = useRef(null);

    const CloudImage = require('../images/SVGs/ICCloud.svg').default;
    const DeviceManager = require('../images/deviceManager.jpg').default;
    const Dashboard = require('../images/UBI3.png').default;
    const Mobile = require('../images/SVGs/mobile1.svg').default;

    const tabBaseClasses =
        'group relative inline-flex flex-col items-center justify-center rounded-xl px-3.5 sm:px-4 md:px-5 py-2.5 text-xs sm:text-sm md:text-base font-semibold tracking-wide transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900';

    return (
        <section className="relative py-16 sm:py-20 lg:py-24">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <div className="pb-4 md:pb-8">
                    {/* ---------------- HEADER ---------------- */}
                    <div
                        className="mx-auto mb-8 max-w-3xl text-center"
                        data-aos-id-tabs
                    >
                        <p
                            className="text-xs font-semibold tracking-widest text-gray-400"
                            data-aos="fade-up"
                            data-aos-anchor="[data-aos-id-tabs]"
                        >
                            SOFTWARE PLATFORM
                        </p>
                        <h2
                            className="mt-3 text-3xl sm:text-4xl font-semibold text-white tracking-tight"
                            data-aos="fade-up"
                            data-aos-delay="100"
                            data-aos-anchor="[data-aos-id-tabs]"
                        >
                            Scalable, flexible, fully agnostic architecture.
                        </h2>
                        <div
                            className="mx-auto mt-4 mb-4 h-1 w-16 rounded-full bg-gradient-to-r from-green-400 via-blue-400 to-purple-400"
                            data-aos="fade-up"
                            data-aos-delay="150"
                            data-aos-anchor="[data-aos-id-tabs]"
                        />
                        <p
                            className="text-sm sm:text-base md:text-lg text-gray-200"
                            data-aos="fade-up"
                            data-aos-delay="200"
                            data-aos-anchor="[data-aos-id-tabs]"
                        >
                            A single platform for device &amp; data - built to integrate into your world.
                        </p>
                    </div>

                    {/* ---------------- TAB STRIP  ---------------- */}
                    <div className="mx-auto max-w-5xl">
                        <div
                            className="relative rounded-2xl border border-gray-800 bg-gray-900 shadow-xl"
                            data-aos="fade-up"
                            data-aos-delay="260"
                            data-aos-anchor="[data-aos-id-tabs]"
                        >
                            <div
                                className="absolute inset-x-6 top-0 h-px bg-gradient-to-r from-green-400 via-blue-400 to-red-400 opacity-80"
                                aria-hidden="true"
                            />
                            <div className="relative flex flex-wrap justify-center gap-3 px-4 py-3 sm:px-6 sm:py-4">
                                {/* IC Cloud */}
                                <button
                                    className={`${tabBaseClasses} ${
                                        tab === 1
                                            ? 'bg-green-400 text-gray-900 shadow-lg ring-2 ring-green-200'
                                            : 'bg-gray-900 text-gray-200 border border-gray-700 hover:bg-gray-800 hover:border-green-300 hover:text-white hover:shadow-md'
                                    }`}
                                    onClick={() => setTab(1)}
                                >
                                    <span className="whitespace-nowrap">IC Cloud</span>
                                    <span className="mt-1 text-xs sm:text-xs text-green-50 opacity-90">
                                        Data &amp; events layer
                                    </span>
                                </button>

                                {/* Device Manager */}
                                <button
                                    className={`${tabBaseClasses} ${
                                        tab === 2
                                            ? 'bg-blue-400 text-gray-900 shadow-lg ring-2 ring-blue-200'
                                            : 'bg-gray-900 text-gray-200 border border-gray-700 hover:bg-gray-800 hover:border-blue-300 hover:text-white hover:shadow-md'
                                    }`}
                                    onClick={() => setTab(2)}
                                >
                                    <span className="whitespace-nowrap">Device Manager</span>
                                    <span className="mt-1 text-xs sm:text-xs text-blue-50 opacity-90">
                                        Hardware control
                                    </span>
                                </button>

                                {/* Dashboard */}
                                <button
                                    className={`${tabBaseClasses} ${
                                        tab === 3
                                            ? 'bg-yellow-400 text-gray-900 shadow-lg ring-2 ring-yellow-200'
                                            : 'bg-gray-900 text-gray-200 border border-gray-700 hover:bg-gray-800 hover:border-yellow-300 hover:text-white hover:shadow-md'
                                    }`}
                                    onClick={() => setTab(3)}
                                >
                                    <span className="whitespace-nowrap">Dashboard</span>
                                    <span className="mt-1 text-xs sm:text-xs text-yellow-50 opacity-90">
                                        Insights &amp; reporting
                                    </span>
                                </button>

                                {/* Mobile Applications */}
                                <button
                                    className={`${tabBaseClasses} ${
                                        tab === 4
                                            ? 'bg-purple-400 text-gray-900 shadow-lg ring-2 ring-purple-200'
                                            : 'bg-gray-900 text-gray-200 border border-gray-700 hover:bg-gray-800 hover:border-purple-300 hover:text-white hover:shadow-md'
                                    }`}
                                    onClick={() => setTab(4)}
                                >
                                    <span className="whitespace-nowrap">Mobile Applications</span>
                                    <span className="mt-1 text-xs sm:text-xs text-purple-50 opacity-90">
                                        Driver &amp; customer apps
                                    </span>
                                </button>

                                {/* Collision Detection */}
                                <button
                                    className={`${tabBaseClasses} ${
                                        tab === 5
                                            ? 'bg-red-400 text-gray-900 shadow-lg ring-2 ring-red-200'
                                            : 'bg-gray-900 text-gray-200 border border-gray-700 hover:bg-gray-800 hover:border-red-300 hover:text-white hover:shadow-md'
                                    }`}
                                    onClick={() => setTab(5)}
                                >
                                    <span className="whitespace-nowrap">Collision Detection</span>
                                    <span className="mt-1 text-xs sm:text-xs text-red-50 opacity-90">
                                        Crash analytics
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ---------------- MAIN CONTENT  ---------------- */}
                    <div
                        className="mt-8 rounded-2xl bg-gray-900 px-4 py-10 sm:px-8 sm:py-12 shadow-2xl ring-1 ring-gray-800 ring-opacity-80"
                        data-aos="fade-in"
                        data-aos-duration="1200"
                        data-aos-anchor-placement="top-bottom"
                    >
                        {/* Tabs content */}
                        <div
                            className="relative mx-auto max-w-6xl"
                            data-aos="fade-up"
                            ref={tabs}
                        >
                            {/* IC Cloud */}
                            <Transition
                                show={tab === 1}
                                appear={true}
                                className="w-full"
                                enter="transition ease-in-out duration-500 transform order-first"
                                enterStart="opacity-0 scale-98"
                                enterEnd="opacity-100 scale-100"
                                leave="transition ease-out duration-300 transform absolute"
                                leaveStart="opacity-100 scale-100"
                                leaveEnd="opacity-0 scale-98"
                            >
                                <div className="pb-3 md:pb-2">
                                    <div
                                        className="grid gap-10 lg:grid-cols-2 lg:items-center"
                                        data-aos-id-target
                                    >
                                        {/* Card */}
                                        <div>
                                            <div className="relative overflow-hidden rounded-2xl bg-green-600 shadow-xl">
                                                <img
                                                    alt="IC Cloud"
                                                    src={CloudImage}
                                                    className="w-full rounded-t-2xl bg-gray-900 p-4 object-contain"
                                                />
                                                <div className="relative p-8">
                                                    <h4 className="text-xl font-bold text-white">
                                                        IC Cloud
                                                    </h4>
                                                    <p className="mt-2 text-md font-light text-white">
                                                        The IC Cloud is a centralised data hub designed
                                                        to seamlessly aggregate information from all
                                                        connected devices in your IC devices ecosystem,
                                                        ensuring it&apos;s accessible from a single location.
                                                        Built for scalability, anonymisation and
                                                        event processing, IC Cloud guarantees data
                                                        privacy and integrity, while providing options
                                                        to enhance data interoperability across systems.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Features */}
                                        <div className="space-y-6">
                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-white shadow-lg">
                                                        <i className="fas fa-sitemap"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Scalable
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Handles extreme peaks in data
                                                        traffic, ensuring consistent performance
                                                        as device counts and data volumes
                                                        increase.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-white shadow-lg">
                                                        <i className="fas fa-file-alt"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Resilient
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        In-built failovers guarantee uninterrupted
                                                        service and data integrity during
                                                        system failures.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-white shadow-lg">
                                                        <i className="fas fa-lock"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Privacy
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Advanced tools to
                                                        anonymise or pseudonymise data ensure
                                                        user privacy and compliance with
                                                        data protection laws.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-white shadow-lg">
                                                        <i className="fas fa-network-wired"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Interoperability
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Flexible push and pull options
                                                        facilitate seamless data exchange with
                                                        other systems.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Transition>

                            {/* Device Manager */}
                            <Transition
                                show={tab === 2}
                                appear={true}
                                className="w-full"
                                enter="transition ease-in-out duration-500 transform order-first"
                                enterStart="opacity-0 scale-98"
                                enterEnd="opacity-100 scale-100"
                                leave="transition ease-out duration-300 transform absolute"
                                leaveStart="opacity-100 scale-100"
                                leaveEnd="opacity-0 scale-98"
                            >
                                <div className="pb-3 md:pb-2">
                                    <div
                                        className="grid gap-10 lg:grid-cols-2 lg:items-center"
                                        data-aos-id-target
                                    >
                                        {/* Card */}
                                        <div>
                                            <div className="relative overflow-hidden rounded-2xl bg-blue-600 shadow-xl">
                                                <img
                                                    alt="Device Manager"
                                                    src={DeviceManager}
                                                    className="w-full rounded-t-2xl object-cover"
                                                />
                                                <div className="relative p-8">
                                                    <h4 className="text-xl font-bold text-white">
                                                        Device Manager
                                                    </h4>
                                                    <p className="mt-2 text-md font-light text-white">
                                                        Device Manager serves as the central command hub
                                                        for the IC ecosystem, enabling comprehensive
                                                        control over all devices from a single unified
                                                        platform. It simplifies the complex task of
                                                        managing diverse devices spread across various
                                                        locations by offering an interface where you can
                                                        monitor performance, update firmware, and
                                                        troubleshoot issues.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Features */}
                                        <div className="space-y-6">
                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg">
                                                        <i className="fas fa-desktop"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Monitor
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Ensure optimal performance and security
                                                        by monitoring device health and
                                                        status in real time.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg">
                                                        <i className="fas fa-wifi"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Over the Air
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Effortlessly update and configure
                                                        devices remotely, increasing efficiency
                                                        without needing physical access.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg">
                                                        <i className="fas fa-newspaper"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Manage
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Simplify management of partner or client
                                                        identities and device ownership so
                                                        control is always clear.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg">
                                                        <i className="fas fa-truck"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Delivery
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Track every step of device shipments
                                                        with precision, from warehouse departure
                                                        to final delivery.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Transition>

                            {/* Dashboard */}
                            <Transition
                                show={tab === 3}
                                appear={true}
                                className="w-full"
                                enter="transition ease-in-out duration-500 transform order-first"
                                enterStart="opacity-0 scale-98"
                                enterEnd="opacity-100 scale-100"
                                leave="transition ease-out duration-300 transform absolute"
                                leaveStart="opacity-100 scale-100"
                                leaveEnd="opacity-0 scale-98"
                            >
                                <div className="pb-3 md:pb-2">
                                    <div
                                        className="grid gap-10 lg:grid-cols-2 lg:items-center"
                                        data-aos-id-target
                                    >
                                        {/* Card */}
                                        <div>
                                            <div className="relative overflow-hidden rounded-2xl bg-yellow-600 shadow-xl">
                                                <img
                                                    alt="Dashboard"
                                                    src={Dashboard}
                                                    className="w-full rounded-t-2xl object-cover"
                                                />
                                                <div className="relative p-8">
                                                    <h4 className="text-xl font-bold text-white">
                                                        Dashboard
                                                    </h4>
                                                    <p className="mt-2 text-md font-light text-white">
                                                        Our dashboard offers a comprehensive view of
                                                        driving data from your devices, presenting
                                                        actionable insights and performance metrics in a
                                                        user-friendly interface. It enables users to
                                                        monitor recent journeys, track historical
                                                        trends, and identify areas for improvement or
                                                        concern. Designed for ease of use, the dashboard
                                                        simplifies the complexity of device data, making
                                                        it accessible for decision-making and analysis.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Features */}
                                        <div className="space-y-6">
                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-white shadow-lg">
                                                        <i className="fas fa-chart-bar"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Analytics
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Monitor each driver individually or
                                                        compare against others, with a deep
                                                        view into efficiency and usage
                                                        patterns.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-white shadow-lg">
                                                        <i className="fas fa-exclamation-circle"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Tamper &amp; inactivity alerts
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Receive notifications for any signs of
                                                        device tampering or removal, protecting
                                                        the integrity of your programmes.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-white shadow-lg">
                                                        <i className="fas fa-list-alt"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Comprehensive
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Detailed views of each journey offer
                                                        insight into usage and enable
                                                        thorough evaluation of performance
                                                        over time.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-white shadow-lg">
                                                        <i className="fas fa-car-crash"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Collision reporting
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Comprehensive collision monitoring
                                                        helps insurers accurately evaluate
                                                        crash events and reduce claims via
                                                        detailed incident analysis.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Transition>

                            {/* Mobile Applications */}
                            <Transition
                                show={tab === 4}
                                appear={true}
                                className="w-full"
                                enter="transition ease-in-out duration-500 transform order-first"
                                enterStart="opacity-0 scale-98"
                                enterEnd="opacity-100 scale-100"
                                leave="transition ease-out duration-300 transform absolute"
                                leaveStart="opacity-100 scale-100"
                                leaveEnd="opacity-0 scale-98"
                            >
                                <div className="pb-3 md:pb-2">
                                    <div
                                        className="grid gap-10 lg:grid-cols-2 lg:items-center"
                                        data-aos-id-target
                                    >
                                        {/* Card */}
                                        <div>
                                            <div className="relative overflow-hidden rounded-2xl bg-purple-600 shadow-xl">
                                                <img
                                                    alt="Mobile Applications"
                                                    src={Mobile}
                                                    className="w-full rounded-t-2xl bg-gray-900 p-4 object-contain"
                                                />
                                                <div className="relative p-8">
                                                    <h4 className="text-xl font-bold text-white">
                                                        Mobile Applications
                                                    </h4>
                                                    <p className="mt-2 text-md font-light text-white">
                                                        Our mobile applications, compatible with both
                                                        iOS and Android, offer an intuitive
                                                        and user-friendly interface that bridges
                                                        companies directly with end-users. They serve as
                                                        a seamless conduit for highlighting areas of
                                                        improvement or extending commendations,
                                                        strengthening feedback loops and engagement.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Features */}
                                        <div className="space-y-6">
                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-purple-600 text-white shadow-lg">
                                                        <i className="fas fa-tag"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Fully white labelled &amp; configurable
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Fully white-labelled apps let your
                                                        brand lead, with configurable journeys
                                                        tailored to your products and markets.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-purple-600 text-white shadow-lg">
                                                        <i className="fas fa-star"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Scoring
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Driver scoring and journey breakdowns
                                                        surface habits and opportunities for
                                                        safer, more efficient driving.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-purple-600 text-white shadow-lg">
                                                        <i className="fas fa-phone"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Direct contact with end user
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Establish a direct line of communication,
                                                        boosting feedback, engagement and
                                                        long-term customer loyalty.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-purple-600 text-white shadow-lg">
                                                        <i className="fas fa-wrench"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Self-install
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        In-app self-install guides make device
                                                        setup simple for users and reduce
                                                        support overhead for your teams.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Transition>

                            {/* Collision Detection */}
                            <Transition
                                show={tab === 5}
                                appear={true}
                                className="w-full"
                                enter="transition ease-in-out duration-500 transform order-first"
                                enterStart="opacity-0 scale-98"
                                enterEnd="opacity-100 scale-100"
                                leave="transition ease-out duration-300 transform absolute"
                                leaveStart="opacity-100 scale-100"
                                leaveEnd="opacity-0 scale-98"
                            >
                                <div className="pb-3 md:pb-2">
                                    <div
                                        className="grid gap-10 lg:grid-cols-2 lg:items-center"
                                        data-aos-id-target
                                    >
                                        {/* Card */}
                                        <div>
                                            <div className="relative overflow-hidden rounded-2xl bg-red-500 shadow-xl">
                                                <div className="bg-gray-900">
                                                    <div className="relative">
                                                        <img
                                                            src={require('../images/worldmap.png').default}
                                                            width="672"
                                                            height="330"
                                                            alt="World map"
                                                            className="w-full object-cover"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '22%', left: '52%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="32"
                                                            height="32"
                                                            alt="Crash 01"
                                                            data-aos="zoom-in"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '50%', left: '58%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="48"
                                                            height="48"
                                                            alt="Crash 02"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="400"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '8.5%', left: '70.5%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="56"
                                                            height="56"
                                                            alt="Crash 03"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="100"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '34%', left: '76.5%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="72"
                                                            height="72"
                                                            alt="Crash 04"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="700"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '29.5%', left: '8.5%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="48"
                                                            height="48"
                                                            alt="Crash 05"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="500"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '56%', left: '19%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="56"
                                                            height="56"
                                                            alt="Crash 06"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="200"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '20%', left: '24.5%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="64"
                                                            height="64"
                                                            alt="Crash 07"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="600"
                                                        />
                                                        <img
                                                            className="absolute rounded-full"
                                                            style={{ top: '39%', left: '43%' }}
                                                            src={require('../images/Icons/car-crash.png').default}
                                                            width="40"
                                                            height="40"
                                                            alt="Crash 08"
                                                            data-aos="zoom-in"
                                                            data-aos-delay="300"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="relative p-8">
                                                    <h4 className="text-xl font-bold text-white">
                                                        Collision Detection
                                                    </h4>
                                                    <p className="mt-2 text-md font-light text-white">
                                                        Our devices leverage a blend of cutting-edge
                                                        hardware and sophisticated software, featuring
                                                        proprietary collision detection technology. This
                                                        allows for precise detection, recording and
                                                        analysis of impacts, ensuring accurate
                                                        evaluations of collision events.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Features */}
                                        <div className="space-y-6">
                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-500 text-white shadow-lg">
                                                        <i className="fas fa-check"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Accurate event discrimination
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Our accelerometer array captures the
                                                        severity, direction and multiple
                                                        impacts of an event, while filtering out
                                                        environmental noise to reduce false
                                                        positives.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-500 text-white shadow-lg">
                                                        <i className="fas fa-map-marker"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Local event detection
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Crash events are detected in real time
                                                        directly on the device — not in the
                                                        cloud — transmitting only valid events
                                                        to minimise data overhead.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="grid gap-6 sm:grid-cols-2">
                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-500 text-white shadow-lg">
                                                        <i className="fas fa-file"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        Analytical data provision
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        A &quot;camera roll&quot; of sensor data captures
                                                        crash impacts before, during
                                                        and after the event; qualified events are
                                                        analysed to refine and create new
                                                        event profiles.
                                                    </p>
                                                </div>

                                                <div className="rounded-2xl bg-gray-900 bg-opacity-70 px-4 py-5 shadow-md">
                                                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-500 text-white shadow-lg">
                                                        <i className="fas fa-wifi"></i>
                                                    </div>
                                                    <h6 className="mb-1 text-xl font-semibold text-white">
                                                        &quot;Over the air&quot; configuration
                                                    </h6>
                                                    <p className="text-sm text-gray-300">
                                                        Configurable event profiles stored
                                                        locally can be set and deployed
                                                        remotely, globally or per device,
                                                        offering flexible management options.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Transition>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PlatformTabs;
